import { NotasFeErratas } from "../../home/dialog/nota-fe-errata/nota-fe-errata.component";
import { DatosSerieResponse } from "./DatosSerieResponse";
import { EncabezadoTabla } from "./encabezado-tabla";
import { InformacionSerie } from "./informacion-serie";

export class DataAccordion {
        id!: number;
        id_padre!: number;
        nombre!: string;

        enlace_pagina_externa!: string;
        enlace_reporte_tabla!: string;
        enlace_reporte_grafica!: string;
        enlace_dashboard!: string;

        display:boolean = true;
        iconDisplay:string = 'add';
        classSelected:string = 'no-selected';

        menuHijos: Array<DataAccordion> = new Array();

        encabezadoTabla: Array<EncabezadoTabla> = new Array();
        datosTablaSerie: Array<Array<InformacionSerie>> = new Array();
        informacionSerie: DatosSerieResponse = new DatosSerieResponse();
        guiasNotas:Array<NotasFeErratas>=[];

        definicion:string = '';

        expanded: boolean = false;
}